import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-left",
  "use": "icon-chevron-left-usage",
  "viewBox": "-6 -4 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-6 -4 30 30\" id=\"icon-chevron-left\">\r\n\t<path d=\"M2.68 7.01l5.2 5.42c.16.17.16.34 0 .5l-.94.94c-.18.16-.35.17-.5.03L.09 7.26C.03 7.2 0 7.12 0 7.01c0-.1.03-.19.09-.25L6.44.12c.17-.16.34-.16.5 0l.94.97c.16.17.16.33 0 .5z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol